import defaultSettings from '@/settings'
import { useDynamicTitle } from '@/utils/dynamicTitle'
import { ElLoading } from 'element-plus'

const { sideTheme, showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle,drawerDirection } = defaultSettings

const storageSetting = JSON.parse(localStorage.getItem('layout-setting')) || ''

const useSettingsStore = defineStore(
  'settings',
  {
    state: () => ({
      title: '',
      theme: storageSetting.theme || '#206CFF',
      sideTheme: storageSetting.sideTheme || sideTheme,
      showSettings: showSettings,
      topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
      tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
      fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
      sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
      dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle,
      drawerDirection:storageSetting.drawerDirection === undefined ? drawerDirection : storageSetting.drawerDirection
    }),
    actions: {
      // 修改布局设置
      changeSetting(data) {
        const { key, value } = data
        if (this.hasOwnProperty(key)) {
          this[key] = value
        }
      },
      // 设置网页标题
      setTitle(title) {
        this.title = title
        useDynamicTitle();
      },
      /* 开启关闭遮罩层
       * @params {string} clsName - 遮罩层绑定的dom的 class
       * */
      toggleLoading(type='close',clsName=null) {
        if (type==='close') {
          this.loadingInstance?.close()
          this.loadingInstance = null
        } else if(!this.loadingInstance) {
          const params = clsName ? {
            target: clsName,
            text: '加载中...',
            background: 'rgba(255,255,255, 0.8)',
            lock: true,
          } : { fullscreen: true }
          this.loadingInstance = ElLoading.service(params)
        }
      }
    }
  })

export default useSettingsStore
